/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";

export default class ClaimNotes extends BaseCom {
    async componentDidMount() {
        await this.fillItemAsync('/api/visit/note?visitId=' + this.props.visitID, 'notes');
        this.setState({ examination: JSON.parse(this.props.examinationJsonData) });
    }

    render() {
        return (
            <Card title="Notes">
                <p>{this.state.notes?.note}</p>
                <p>{this.state.notes?.medicalHx}</p>
                <p>{this.state.notes?.woundHx}</p>
                <p>{this.state.examination?.woundCareOrders}</p>
                <p>{this.state.examination?.woundCarePlan}</p>
                {this.state.examination?.woundPosList?.map((i, idx) => <p key={idx}>
                    Wound {i.idx}: {i.notes}
                </p>)}
                {this.state.examination?.woundPosFeetList?.map((i, idx) => <p key={idx}>
                    Wound {i.idx}: {i.notes}
                </p>)}
            </Card>
        );
    }
}